<template>
    <div class="annotation-container no-select"
         :class="data.classAnnotationContainer"
         :id="`annotation-container-${props.pagenum}`"
    >
        <template v-for="(item, key) in annot.annotList">

            <go-to-page v-if="item.isGoToPageBtn"
                        :annot="item"
            >
            </go-to-page>


            <toggle-han-pin-btn  v-if="item.isToggleHan || item.isTogglePinYin"
                                 :annot="item"
                                 :pagenum="props.pagenum"
            >
            </toggle-han-pin-btn>

            <han-pin v-if="item.isHanPin && !item.redundant"
                     :annot="item"
                     :pagenum="props.pagenum"
            >
            </han-pin>


            <toggle-hints v-if="item.isToggleHints && !item.redundant"
                          :annot="item"
                          :pagenum="props.pagenum"
                          :sharedMeta="annot.sharedMeta['toggleHintsIdMapping']"
            >
            </toggle-hints>

            <toggle-hints-btn v-if="item.isToggleHintsBtn "
                              :annot="item"
                              :pagenum="props.pagenum"
            >
            </toggle-hints-btn>

            <toggle-all-hints-btn v-if="item.isToggleAllHintsBtn "
                              :annot="item"
                              :pagenum="props.pagenum"
            >
            </toggle-all-hints-btn>

            <gif-display v-if="item.isGif"
                         :annot="item"
            ></gif-display>

            <show-resource-btn v-if="item.isShowResourceBtn "
                              :btnId = key
                              :pagenum = "props.pagenum"
                              :annot="item"
            >
            </show-resource-btn>

            <step-by-step-btn v-if="item.isStepByStepBtn "
                                   :annot="item"
                                   :pagenum = "props.pagenum"
                                   :sharedMeta="annot.sharedMeta['stepByStep']"
            >
            </step-by-step-btn>

            <step-by-step-slide v-if="annot.annotTypes.includes('stepByStep') && item.isStepByStep"
                                :annot="item"
                                :pagenum = "props.pagenum"
                                :sharedMeta="annot.sharedMeta['stepByStep']"
            >

            </step-by-step-slide>

            <video-display v-if="annot.sharedMeta['inlineVideoId']!== undefined && item.isContentRect &&  bookInfoState.activeVideoData !== null && bookInfoState.activeVideoData.targetRectId === item.id && bookInfoState.activeVideoData.pagenum === props.pagenum"
                           :annot="item"
            >
            </video-display>

            <karaoke-row v-if="item.isKaraokeRow"
                         :annot="item"
                         :sharedMeta="annot.sharedMeta['karaoke']"
                         :pagenum = "props.pagenum"
            >
            </karaoke-row>

            <play-karaoke-btn v-if="item.isPlayKaraokeBtn"
                              :annot="item"
                              :pagenum="props.pagenum"
                              :sharedMeta="annot.sharedMeta['karaoke']"
            >
            </play-karaoke-btn>

            <play-multi-page-karaoke-btn  v-if="item.isPlayMultiPageKaraokeBtn "
                                          :annot="item"
                                          :pagenum="props.pagenum"
                                          :annotTypes = "annot.annotTypes"
                                          :sharedMeta="annot.sharedMeta"
                                          :playPageKaraokeBtnData="data.playPageKaraokeBtnData"
            >
            </play-multi-page-karaoke-btn>


            <play-page-karaoke-btn v-if="item.isPlayPageKaraokeBtn "
                              :annot="item"
                              :pagenum = "props.pagenum"
                              :sharedMeta="annot.sharedMeta['karaoke']"
            >
            </play-page-karaoke-btn>

            <play-block-btn v-if="item.isPlayBlockBtn "
                              :annot="item"
                              :pagenum = "props.pagenum"
                              :sharedMeta="annot.sharedMeta['karaoke']"
            >
            </play-block-btn>


            <play-multi-page-block-btn v-if="item.isPlayMultiPageBlockBtn "
                                       :annot="item"
                                       :sharedMeta="annot.sharedMeta['karaoke']"

            >
            </play-multi-page-block-btn>

            <play-span v-if="item.isPlaySpan || item.isPlayMultipleSpan"
                       :pagenum = "props.pagenum"
                       :annot="item"
            >
            </play-span>

            <mute-role v-if="item.isMuteRole"
                       :annot="item"
                       :pagenum = "props.pagenum"
            >
            </mute-role>


            <inline-exercise v-if="item.isInlineExercise"
                             :annot="item"
                             :pagenum = "props.pagenum"

            >
            </inline-exercise>

        </template>

        <!-- Glossary -->
        <Glossary v-if="bookInfoState.activeGlossaryData && bookInfoState.activeGlossaryData.isShow === true && bookInfoState.activeGlossaryData.pagenum === props.pagenum">

        </Glossary>

    </div>
</template>

<script>

    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick}  from "vue";
    import {useParser} from "@/modules/reader/annotations/parser";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {useTool} from "@/modules/reader/tools/tools";
    import cssvar from '@/scss/_variables.scss';
    import GoToPage from "@/views/reader/annotations/goToPage/GoToPage";
    import ToggleHints from "@/views/reader/annotations/toggleHints/ToggleHints";
    import ToggleAllHintsBtn from "@/views/reader/annotations/toggleHints/ToggleAllHintsBtn";
    import ShowResourceBtn from "@/views/reader/annotations/showResource/ShowResourceBtn";
    import StepByStepBtn from "@/views/reader/annotations/stepByStep/StepByStepBtn";
    import StepByStepSlide from "@/views/reader/annotations/stepByStep/StepByStepSlide";
    import PlayKaraokeBtn from "@/views/reader/annotations/karaoke/PlayKaraokeBtn";
    import PlayPageKaraokeBtn  from "@/views/reader/annotations/karaoke/PlayPageKaraokeBtn";
    import PlayMultiPageKaraokeBtn from "@/views/reader/annotations/karaoke/PlayMultiPageKaraokeBtn";
    import PlayBlockBtn from "@/views/reader/annotations/karaoke/PlayBlockBtn";
    import PlayMultiPageBlockBtn from "@/views/reader/annotations/karaoke/PlayMultiPageBlockBtn";
    import ToggleHintsBtn from "@/views/reader/annotations/toggleHints/ToggleHintsBtn";
    import ToggleHanPinBtn from "@/views/reader/annotations/hanpin/ToggleHanPinBtn";
    import HanPin from "@/views/reader/annotations/hanpin/HanPin";
    import PlaySpan from "@/views/reader/annotations/karaoke/PlaySpan";
    import MuteRole from "@/views/reader/annotations/karaoke/MuteRole";
    import KaraokeRow from "@/views/reader/annotations/karaoke/KaraokeRow";
    import VideoDisplay from "@/views/reader/annotations/showResource/VideoDisplay";
    import Glossary from "@/views/reader/annotations/showResource/Glossary";
    import PopUp from "@/views/reader/popup/PopUp";
    import GifDisplay from "@/views/reader/annotations/showResource/GifDisplay";
    import InlineExercise from "@/views/reader/annotations/inlineExercise/InlineExercise";

    const colorRect = cssvar.colorRect;

    export default {

        components: {
            HanPin,
            GoToPage,
            ToggleHints,
            KaraokeRow,
            PlayKaraokeBtn,
            PlayPageKaraokeBtn,
            PlayMultiPageKaraokeBtn,
            PlayBlockBtn,
            PlayMultiPageBlockBtn,
            PlaySpan,
            MuteRole,
            ToggleHintsBtn,
            ToggleAllHintsBtn,
            ToggleHanPinBtn,
            ShowResourceBtn,
            StepByStepBtn,
            StepByStepSlide,
            VideoDisplay,
            Glossary,
            PopUp,
            InlineExercise,
            GifDisplay
        },
        props: {
            annot:Object,
            pagenum:Number
        },
        setup(props, context) {

            const {readData} = useParser();
            const {bookInfoState} = useBookInfo();
            const {toolState} = useTool();
            const data = reactive({
                playPageKaraokeBtnData:computed(()=>{
                    for (let item of props.annot.annotList) {
                        if (item.isPlayPageKaraokeBtn) {
                            return item;
                        }
                    }
                    return;
                }),
                classAnnotationContainer:computed(()=>{
                    nextTick(()=> {
                        return {
                            "annotation-container-up": !toolState.isUsing
                        }
                    });
                })
            })

            onMounted(() => {

            });

            return {
                props,
                bookInfoState,
                data
            }

        }
    }
</script>

<style scoped lang="scss">

    .annotation-container {
        position:absolute;
        width:100%;
        height:100%;
    }

    .annotation-container-up {
        z-index:$zindex-annot-layer;
    }

    #glossary-loading {
        width:100%;
        height:100%;
        position:fixed;
        background:rgba(255,255,255,0.6);
        z-index:$zindex-glossary-loading;
        display: flex;
        align-items: center;
        justify-content: center;
    }

</style>